import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sgm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

/**
 * Chiamata autenticata per scaricamenti e invii di file, dove axios non serve.
 *
 * Manda sia il token sia il cookie di sessione, perché i due non vivono
 * insieme: il cookie vale su tutta l'applicazione, il token sta nella memoria
 * locale del browser, che è separata per dominio. Chi arriva da un indirizzo
 * diverso risulta collegato grazie al cookie ma non ha il token, e senza
 * questo doppio invio ogni download risponderebbe "token non valido".
 */
export async function authFetch(path, options = {}) {
  const token = localStorage.getItem("sgm_token");
  const headers = { ...(options.headers || {}) };
  if (token) headers.Authorization = `Bearer ${token}`;
  return fetch(`${API}${path}`, { ...options, headers, credentials: "include" });
}

export default api;
